import * as React from 'react';

import { TabProps } from './Tab';
import { CustomTabPanel } from './CustomTabPanel';
import styles from "./styles.module.scss";

interface TabsProps {
    children: React.ReactElement<TabProps>[];
    value: number;
    onChange: (newValue: number) => void;
}

const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const Tabs = ({ children, value, onChange }: TabsProps) => {
    return (
        <div>
            <div className={styles.tabContainer}>
                <div role="tablist" className={styles.tabsButttonContainer} >
                {
                    React.Children.map(children, (child, index) => {
                        return React.cloneElement(child, {
                            ...a11yProps(index),
                            onClick: () => onChange(index),
                            "aria-selected": value === index,
                        });
                    })
                }
                </div>
        </div>
            {
        React.Children.map(children, (child, index) => (
            <CustomTabPanel value={value} index={index}>
                {child.props.children}
            </CustomTabPanel>
        ))
    }
        </div >
    );
};